<template>
<div class="form-group">
  <label :for="inputId" >{{label}}</label>
  <this-masked-input :name="inputId"  :id="inputId" v-validate="validationRule" :value="value"  :class="{'input form-control': true, 'is-invalid form-control': errors.has(inputId) }"  mask="(111) 111-1111" :placeholder="label" @input="changeInput"></this-masked-input>
  <span v-show="errors.has(inputId)" class="help is-invalid">{{ errors.first(inputId) }}</span>
</div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueMaskedInput from 'vue-masked-input'
Vue.use(VeeValidate, { fastExit: false })

export default {
  inject: ['$validator'],
  props: {
    value: { type: String },
    inputId: { type: String },
    label: { type: String },
    validationRule: { type: String, default: '' }
  },
  components: {
    'this-masked-input': VueMaskedInput
  },
  methods: {
    changeInput: function (num) {
      this.$emit('input', num)
    }
  }
}
</script>



// WEBPACK FOOTER //
// fax-number-input.vue?3cb757ad